import { NgModule } from '@angular/core';
import { Routes, RouterModule, mapToCanActivate, mapToResolve } from '@angular/router';
import { MaintenanceGuard } from '../../guards/maintenance.guard';
import { AuthGuard } from '../../services/auth.guard';
import { SelfServiceComponent } from './self-service.component';
import { SelfServiceResolver } from './self-service.resolver';

const routes: Routes = [
    {
        path: '',
        component: SelfServiceComponent,
        resolve: {
            user: mapToResolve(SelfServiceResolver),
        },
        canActivate: mapToCanActivate([AuthGuard, MaintenanceGuard]),
        children: [
            {
                path: '',
                loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
            },
            {
                path: 'personal-data',
                loadChildren: () =>
                    import('./modules/personal-data/personal-data.module').then((m) => m.PersonalDataModule),
            },
            {
                path: 'notifications',
                loadChildren: () =>
                    import('./modules/notifications/notifications.module').then((m) => m.NotificationsModule),
            },
            {
                path: 'company-data',
                loadChildren: () =>
                    import('./modules/company-data/company-data.module').then((m) => m.CompanyDataModule),
            },
            {
                path: 'employees',
                loadChildren: () => import('./modules/employees/employees.module').then((m) => m.EmployeesModule),
            },
            {
                path: 'purchases',
                loadChildren: () =>
                    import('./modules/purchases-and-subscriptions/purchases-and-subscriptions.module').then(
                        (m) => m.PurchasesAndSubscriptionsModule
                    ),
            },
            {
                path: 'roles-and-permissions',
                loadChildren: () =>
                    import('./modules/roles-and-permissions/roles-and-permissions.module').then(
                        (m) => m.RolesAndPermissionsModule
                    ),
            },
            {
                path: 'settings',
                loadChildren: () => import('./modules/settings/settings.module').then((m) => m.SettingsModule),
            },
        ],
    },
    {
        path: 'incorrect-customer-data',
        // tslint:disable:max-line-length
        loadChildren: () =>
            import('./modules/incorrect-customer-data/incorrect-customer-data.module').then(
                (m) => m.IncorrectCustomerDataModule
            ),
        // tslint:enable:max-line-length
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class SelfServiceRoutingModule {}
